import(/* webpackMode: "eager" */ "/opt/voicesphereai-frontend/src/app/page.jsx");
